import REST from 'api/rest';

class AuthAPI extends REST {
	constructor() {
		super();
		this.baseURL = `${window.config.baseurl}wp-json/jwt-auth/v1`;
	}

	/**
	 * Login User
	 */
	loginUser(username, password) {
	  return this._request('post', 'token', null, {
	    username,
	    password
	  });
	}

	/**
	 * Check Token
	 */
	checkToken() {
	  return this._request('post', 'token/validate');
	}
}

const api = new AuthAPI();

export default api;



// WEBPACK FOOTER //
// ./src/api/auth.js